import React, { useState, useEffect, useRef } from "react";
import "../../../../StyleSheet/AppComponent/InputFields/Otp/Otp.scss";
import { getOtpVerifyActions, GetResendPerson } from "../../../../Redux/Slice";
import { useDispatch, useSelector } from "react-redux";
import CustomButton from "../../CustomButton/CustomButton";
import data from "../../../../Json/Language/English";
import hindiDatas from "../../../../Json/Language/Hinid";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
const OTP = (props) => {
  const EnglishData = data;
  const HindiData = hindiDatas;
  const { value, onChange } = props;
  const State = useSelector((state) => state);
  // const [otp, setOTP] = useState('');
  const [timer, setTimer] = useState(90);
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [OtpNumber, setOtpNumber] = useState();
  const dispatch = useDispatch();
  const handleOTPChange = (e, index) => {
    const newOtp = [...otp];
    newOtp[index] = e.target.value.slice(0, 1);
    setOtpNumber(e.target.value);
    console.log(e.target.value, "opoasda");
    if (index < otp.length - 1 && e.target.value !== "") {
      const nextInput = e.target.nextSibling;
      if (nextInput) {
        nextInput.focus();
      }
    }

    setOtp(newOtp);
    console.log(otp, "otpms");
  };
 const navigate = useNavigate()
  const handleSubmit = (e) => {
    e.preventDefault();
    // Perform OTP verification logic here
  };
  const  Funcaiton = ()=>{

    navigate("/resetpassword")
  }
  
  const [concatenNumbers, setConcatenedNumber] = useState("");
  const handleSumit = () => {
    console.log(otp, "numbers");
    const concatedString = otp.join("");
    const ConcatentedNumber = parseInt(concatedString, 10);
    setConcatenedNumber(ConcatentedNumber);
    // setConcatenedNumber()
    console.log(concatedString ,"concatedString", typeof concatedString);
    
  if (concatedString.length === 6 && /^\d{6}$/.test(concatedString)) {
      // console.log(ConcatentedNumber, "sdf");
      const payload = {
        otp: concatedString,
        Funcations: () => {
          // Your function logic here
          console.log('Function called');
          navigate("/resetpassword")

        },
          };
      dispatch(getOtpVerifyActions(payload));
    }
     else {
    toast.error("Please enter a valid OTP before submitting.", {
      position: "top-right",
      autoClose: 3000,
      theme: "colored",
    });
    }
  };

  const [minutes, setMinutes] = React.useState(1);
  const [seconds, setSeconds] = React.useState(30);

  React.useEffect(() => {
    let myInterval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }
      if (seconds === 0) {
        if (minutes === 0) {
          clearInterval(myInterval);
        } else {
          setMinutes(minutes - 1);
          setSeconds(59);
        }
      }
    }, 500);
    return () => {
      clearInterval(myInterval);
    };
  });
  const HandleResend = () => {
    dispatch(GetResendPerson());
  };

  return (
    <div className="Outer-Input">
      {State.Language.Language == "English" ? (
        <>
          {EnglishData.LeftSide.Content.VerifiContent.Content.map((item) => (
            <label>{item.OTP}</label>
          ))}
        </>
      ) : (
        <>
          {HindiData.LeftSide.Content.VerifiContent.Content.map((item) => (
            <label>{item.OTP}</label>
          ))}
        </>
      )}
      {/* <label >Enter  OTP</label> */}
      <div className="otp-container">
        <div className="otp-input">
          {otp.map((digit, index) => (
            <input
              key={index}
              type="number"
              maxLength="1"
              value={digit}
              onChange={(e) => {
                handleOTPChange(e, index);
                setOtpNumber(e.target.value);
              }}
            />
          ))}
        </div>
      </div>

      <div className="timer">
        {State.Language.Language == "English" ? (
          <>
            {EnglishData.LeftSide.Content.VerifiContent.Content2.map((item) => (
              <p>{item.OTP}</p>
            ))}
          </>
        ) : (
          <>
            {HindiData.LeftSide.Content.VerifiContent.Content2.map((item) => (
              <p>{item.OTP}</p>
            ))}
          </>
        )}
        {/* <p> OTP expires in :  </p> */}
        <span>
          {minutes < 10 ? `0${minutes}` : minutes}:
          {seconds < 10 ? `0${seconds}` : seconds}
        </span>
      </div>
      <div className="VeriFyOtp">
        <div className="Verificationcode">
          {State.Language.Language == "English" ? (
            <>
              {EnglishData.LeftSide.Button.Button3.map((item) => (
                <div className="SubmitButton">
                  <CustomButton
                    children="Submit"
                    type="submit"
                    className="ButtonCSS"

                    onClick={handleSumit}
                  >
                    {item.ButtonNameVerify}
                  </CustomButton>
                </div>
              ))}
            </>
          ) : (
            <>
              {HindiData.LeftSide.Button.Button3.map((item) => (
                <div className="SubmitButton">
                  <CustomButton
                    children="Submit"
                    type="submit"
                    className="ButtonCSS"

                    onClick={handleSumit}
                  >
                    {item.ButtonNameVerify}
                  </CustomButton>
                </div>
              ))}
            </>
          )}

          {State.Language.Language == "English" ? (
            <>
              {EnglishData.LeftSide.Content.VerifiContent.Content4.map(
                (item) => (
                  <span>{item.OTP1}</span>
                )
              )}
            </>
          ) : (
            <>
              {HindiData.LeftSide.Content.VerifiContent.Content4.map((item) => (
                <span>{item.OTP1}</span>
              ))}
            </>
          )}

          {/* <span>Didn’t Receive a verification Code ?</span> */}

          {State.Language.Language == "English" ? (
            <>
              {EnglishData.LeftSide.Content.VerifiContent.Content5.map(
                (item) => (
                  <p onClick={HandleResend}>{item.OTP2}</p>
                )
              )}
            </>
          ) : (
            <>
              {HindiData.LeftSide.Content.VerifiContent.Content5.map((item) => (
                <p onClick={HandleResend}> {item.OTP2}</p>
              ))}
            </>
          )}
          {/* <p onClick={e => window.location.reload()}>Resend OTP?</p> */}
        </div>
      </div>
    </div>
  );
};

export default OTP;
